import App from './components/app'

/* global navigator, window */

if (
  typeof window !== 'undefined' &&
  window.location.host === 'podporuji.rekonstrukcestatu.cz' &&
  typeof navigator !== 'undefined' &&
  typeof navigator.serviceWorker !== 'undefined'
) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(r => {
      r.unregister()
    })
  })
}

export default App



// WEBPACK FOOTER //
// ./index.js